import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import StepUpCallbackHandler from './StepUpCallbackHandler';
import { Progress } from '@awesomecomponents/mux';
import ERROR_CODES from '../utils/ErrorCodes';
import { useContext } from 'react';
import LoggerContext from '../utils/logger/LoggerContext';

const StepUpHandler = ({ oidc }) => {
  const logger = useContext(LoggerContext);
  const handler = new StepUpCallbackHandler();

  const history = useHistory();

  const callbackHandler = async (jwt, sessionCorrelationId, formName, lang) => {
    try {
      const authUrl = await handler.callbackHandler(jwt, sessionCorrelationId, formName, lang);

      // Proceed to auth flow
      history.push(authUrl);
    } catch (error) {
      logger.error(`StepUpHandler: Error: ${error.message} Code: ${ERROR_CODES.GET_TRANSFER_TOKEN_FAILED}`);
      // Show 401 error when step up is unsuccessful
      history.push({ pathname: '/app/sde/error', state: { error: ERROR_CODES.GET_TRANSFER_TOKEN_FAILED } });
    }
  };

  useEffect(() => {
    oidc.stepUpCallback(callbackHandler, logger);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oidc]);

  return <Progress />;
};

export default StepUpHandler;
